export default "/_assets/dropdown.3b92a575.svg"